import { useEffect, useState } from "react";
import { listAudit } from "../api/reports";
import { ApiError } from "../api/client";
import type { AccessAuditEvent } from "../types";
import { PageHeader } from "../components/Chrome";

// A8 — audit log. Read-only, paginated.
export function AdminAudit({ tenantSlug }: { tenantSlug: string }) {
  const [events, setEvents] = useState<AccessAuditEvent[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        setEvents(await listAudit(tenantSlug, 200));
      } catch (e) {
        setError(e instanceof ApiError ? e.detail : (e as Error).message);
      }
    })();
  }, [tenantSlug]);

  return (
    <div className="container">
      <PageHeader title="Audit log" />
      {error && <div className="empty err">{error}</div>}
      {events === null && !error && <div className="empty">Loading…</div>}
      {events && events.length === 0 && (
        <div className="empty">No audit events yet.</div>
      )}
      {events && events.length > 0 && (
        <table className="audit-table">
          <thead>
            <tr>
              <th>When</th>
              <th>Actor</th>
              <th>Action</th>
              <th>Target</th>
            </tr>
          </thead>
          <tbody>
            {events.map((e) => (
              <tr key={e.id}>
                <td>{e.occurred_at}</td>
                <td>{e.actor_email}</td>
                <td>{e.action}</td>
                <td>
                  {e.target_member_email ?? "—"}
                  {e.target_page_name ? ` · ${e.target_page_name}` : ""}
                  {e.target_feature_name ? ` › ${e.target_feature_name}` : ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
